import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAcceptConflict = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M10.4111 5.18555C10.5847 4.97089 10.8995 4.93782 11.1143 5.11133C11.3288 5.28492 11.3628 5.59977 11.1895 5.81445L7.00293 10.9922L4.81348 8.31641C4.63861 8.10268 4.67007 7.78815 4.88379 7.61328C5.09751 7.43849 5.41207 7.4699 5.58691 7.68359L6.99707 9.40723L10.4111 5.18555Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8 1L14 3V8L13.9941 8.31152C13.9346 9.84697 13.4289 11.0762 12.4775 12.3242C11.5524 13.5379 9.5257 14.5478 8 15C6.56979 14.5761 4.77834 13.7658 3.72363 12.5693L3.52246 12.3242C2.50765 10.9929 2 9.68299 2 8V3L8 1ZM3 3.71973V8C3 9.4366 3.41759 10.5384 4.31738 11.7188C5.08214 12.7219 6.60497 13.4973 8.00293 13.9502C8.62771 13.7429 9.32653 13.443 9.9707 13.0781C10.7291 12.6485 11.3367 12.1725 11.6826 11.7188C12.5824 10.5384 13 9.4366 13 8V3.71973L8 2.05371L3 3.71973Z'
    />
  </svg>
);
export default SvgAcceptConflict;
